(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    document.querySelectorAll('details[data-auto-close-details][open]').forEach(function (details) {
      var mode = window.innerWidth < 750 ? 'mobile' : 'desktop';
      if (details.getAttribute('data-auto-close-details').includes(mode) && !details.contains(event.target)) {
        details.removeAttribute('open');
      }
    });
  });

  var STORE = 'gs_recently_viewed_products_v1';
  var LEGACY = 'gs_recent_products_v2';
  var LINE = 'https://line.me/R/oaMessage/%40802oyioy/?';
  var cache = new Map();
  var queued = false;

  function english() {
    return String(document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  }

  function productPage() {
    var value = document.querySelector('main[data-template]')?.getAttribute('data-template') || '';
    return value === 'product' || value.indexOf('product.') === 0;
  }

  function rootPath() {
    var root = String(window.Shopify?.routes?.root || '/');
    return root.endsWith('/') ? root : root + '/';
  }

  function parse(value) {
    try {
      var result = JSON.parse(value || '[]');
      return Array.isArray(result) ? result : [];
    } catch (_) {
      return [];
    }
  }

  function handle(value) {
    var raw = String(value || '');
    var match = raw.match(/\/products\/([^/?#]+)/i);
    if (match) {
      try { return decodeURIComponent(match[1]).replace(/\.js$/i, ''); } catch (_) { return match[1]; }
    }
    return raw.replace(/^https?:\/\/[^/]+/i, '').replace(/^\/+|\/+$/g, '')
      .replace(/^[a-z]{2}(?:-[a-z]{2})?\//i, '').replace(/^products\//i, '')
      .replace(/[?#].*$/, '').replace(/\.js$/i, '');
  }

  function key(item) {
    if (item && item.id !== undefined && item.id !== null && String(item.id)) return 'id:' + item.id;
    var h = handle(item && (item.handle || item.url));
    return h ? 'handle:' + h : '';
  }

  function read(name) {
    try { return parse(localStorage.getItem(name)); } catch (_) { return []; }
  }

  function write(items) {
    var seen = new Set();
    var output = [];
    items.sort(function (a, b) { return Number(b.viewed_at || b.timestamp || 0) - Number(a.viewed_at || a.timestamp || 0); });
    items.forEach(function (item) {
      var k = key(item);
      if (!k || seen.has(k) || output.length >= 24) return;
      seen.add(k);
      item.handle = item.handle || handle(item.url);
      output.push(item);
    });
    try {
      localStorage.setItem(STORE, JSON.stringify(output));
      localStorage.removeItem(LEGACY);
      localStorage.removeItem('viewedProducts');
      localStorage.removeItem('recently-viewed-products');
    } catch (_) {}
    return output;
  }

  function migrate() {
    write(read(STORE).concat(read(LEGACY)));
  }

  function endpoint(h, localized) {
    return (localized ? rootPath() : '/') + 'products/' + encodeURIComponent(h) + '.js';
  }

  async function getProduct(h) {
    if (!h) return null;
    var cacheKey = document.documentElement.lang + '|' + h;
    if (!cache.has(cacheKey)) {
      cache.set(cacheKey, (async function () {
        for (var localized of [true, false]) {
          try {
            var response = await fetch(endpoint(h, localized), {
              headers: { Accept: 'application/json' }, credentials: 'same-origin'
            });
            if (response.ok) return await response.json();
          } catch (_) {}
        }
        return null;
      })());
    }
    return cache.get(cacheKey);
  }

  function imageUrl(product) {
    if (typeof product?.featured_image === 'string') return product.featured_image;
    if (product?.featured_image?.src) return product.featured_image.src;
    var first = product?.images?.[0];
    return typeof first === 'string' ? first : first?.src || '';
  }

  function productUrl(product, fallback) {
    var url = String(product?.url || '');
    if (url) {
      try { return new URL(url, location.origin).pathname; } catch (_) {}
    }
    var h = handle(product?.handle || fallback);
    return h ? rootPath() + 'products/' + encodeURIComponent(h) : '';
  }

  function money(value) {
    if (!Number.isFinite(Number(value))) return '';
    return new Intl.NumberFormat(english() ? 'en-US' : 'ja-JP', {
      style: 'currency', currency: 'JPY', maximumFractionDigits: 0
    }).format(Number(value) / 100);
  }

  function updateLinks(card, product, fallback) {
    var url = productUrl(product, fallback);
    if (!url) return;
    card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      var suffix = '';
      try {
        var old = new URL(link.href, location.origin);
        suffix = old.search + old.hash;
      } catch (_) {}
      link.href = url + suffix;
    });
  }

  async function hydrateRecent(card) {
    if (card.dataset.gsLoading === '1') return;
    var link = card.querySelector('.gs-rv-product-title[href*="/products/"],a[href*="/products/"]');
    var h = handle(link?.getAttribute('href'));
    var mark = document.documentElement.lang + '|' + h;
    if (!h || card.dataset.gsHydrated === mark) return;
    card.dataset.gsLoading = '1';
    var product = await getProduct(h);
    delete card.dataset.gsLoading;
    if (!product?.title) return;
    var title = card.querySelector('.gs-rv-product-title,.gs-recent-product-title');
    var image = card.querySelector('.gs-rv-image,.gs-recent-image');
    var price = card.querySelector('.gs-rv-price,.gs-recent-price');
    if (title) title.textContent = product.title;
    if (image) { if (imageUrl(product)) image.src = imageUrl(product); image.alt = product.title; }
    if (price && product.price !== undefined) price.textContent = money(product.price);
    updateLinks(card, product, h);
    card.dataset.gsTitle = product.title;
    card.dataset.gsHydrated = mark;
  }

  async function hydrateWishlist(card) {
    if (productPage() || card.dataset.gsLoading === '1') return;
    var link = card.querySelector('a[href*="/products/"]');
    var h = handle(link?.getAttribute('href'));
    var mark = document.documentElement.lang + '|' + h;
    if (!h || card.dataset.gsHydrated === mark) return;
    card.dataset.gsLoading = '1';
    var product = await getProduct(h);
    delete card.dataset.gsLoading;
    if (!product?.title) return;
    var title = card.querySelector('.wishlist-storefront-page__card-title');
    var image = card.querySelector('.wishlist-storefront-page__card-image');
    var placeholder = card.querySelector('.wishlist-storefront-page__card-placeholder');
    if (title) title.textContent = product.title;
    if (image) { if (imageUrl(product)) image.src = imageUrl(product); image.alt = product.title; }
    else if (placeholder && imageUrl(product)) {
      var created = document.createElement('img');
      created.className = 'wishlist-storefront-page__card-image';
      created.src = imageUrl(product); created.alt = product.title; created.loading = 'lazy';
      placeholder.replaceWith(created);
    }
    updateLinks(card, product, h);
    card.dataset.gsHydrated = mark;
  }

  var exact = new Map([
    ['気になる天然石を追加済み', 'Added to Wishlist'],
    ['気になる天然石を追加', 'Add to Wishlist'],
    ['まだ気になる天然石はありません。', 'No bracelets have been saved yet.'],
    ['気になる商品は♡から保存出来ます。', 'Save bracelets you love by tapping the heart icon.'],
    ['カートに追加', 'Add to Cart'], ['お気に入りから削除', 'Remove from Wishlist'],
    ['画像なし', 'No image available'],
    ['Top Quality', 'Guiding Stones Signature Selection'],
    ['Premium Quality', 'Guiding Stones Premium Selection'],
    ['High Quality', 'Guiding Stones Fine Selection'],
    ['Gem Report Included', 'Gem Identification Report Included'],
    ['Gem Report Available', 'Gem Identification Report Available'],
    ['Gem Report', 'Gem Identification Report'],
    ['14 mm+ Beads', 'Large Beads 14 mm+'],
    ['Firework Super Seven', 'Hanabi Super Seven Quartz'],
    ['For the self that chose change', 'For a New Direction'],
    ['Preference at first sight, beyond meanings', 'Choose by What Catches Your Eye'],
    ['Select the condition that matters most to you now', 'Choose the factor that matters most to you'],
    ['Do not decide while you are still unsure', 'Choose Only After Your Questions Are Answered'],
    ['Welcome only the one piece', 'Choose only the piece'],
    ['you feel sure about', 'that feels right to you'],
    ['I will treasure wearing it from now on.', 'I look forward to wearing and caring for it for years to come.'],
    ['I was moved by the many gifts!!', 'I truly appreciated the thoughtful extras.'],
    ['The actual item is lovely.', 'The bracelet is even more beautiful in person.']
  ]);

  var embedded = [
    ['Guiding Stones Top Selection', 'Guiding Stones Signature Selection'],
    ['Guiding Stones Quality Selection', 'Guiding Stones Fine Selection'],
    ['Natural Stone Bracelet', 'Natural Gemstone Bracelet'],
    ['Stone Record No.', 'Stone Record ID'], ['STONE RECORD No.', 'STONE RECORD ID'],
    ['Firework Super Seven', 'Hanabi Super Seven Quartz'],
    ['Gem Report Included', 'Gem Identification Report Included'],
    ['Gem Report Available', 'Gem Identification Report Available'],
    ['Gem Report', 'Gem Identification Report'],
    ['[Top Quality]', '[Guiding Stones Signature Selection]'],
    ['[Premium Quality]', '[Guiding Stones Premium Selection]'],
    ['[High Quality]', '[Guiding Stones Fine Selection]']
  ];

  function translate(value) {
    var result = String(value || '');
    var trimmed = result.trim();
    if (exact.has(trimmed)) return result.replace(trimmed, exact.get(trimmed));
    embedded.forEach(function (pair) { result = result.split(pair[0]).join(pair[1]); });
    return result;
  }

  function normalize(root) {
    if (!english() || !(root instanceof Element)) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (node.parentElement?.closest('script,style,textarea,pre,code')) return;
      var output = translate(node.nodeValue);
      if (output !== node.nodeValue) node.nodeValue = output;
    });
    root.querySelectorAll('[aria-label],[title],[placeholder],[alt],input[value]').forEach(function (element) {
      ['aria-label', 'title', 'placeholder', 'alt', 'value'].forEach(function (attribute) {
        if (!element.hasAttribute(attribute)) return;
        var current = element.getAttribute(attribute);
        var output = translate(current);
        if (output !== current) element.setAttribute(attribute, output);
      });
    });
  }

  function stoneRecord() {
    if (!english()) return;
    document.querySelectorAll('.gs-stone-record-page:not([data-gs-english-ready])').forEach(function (page) {
      page.dataset.gsEnglishReady = 'true';
      page.innerHTML = '<section style="max-width:760px;margin:32px auto;padding:32px 20px;text-align:center;background:#fffdf8;border:1px solid #d8c79b;border-radius:16px;color:#2c251d"><p style="margin:0 0 8px;color:#9b7c31;font-size:11px;font-weight:700;letter-spacing:.16em">GUIDING STONES OWNER RECORD</p><h1 style="margin:0 0 14px;font-size:clamp(28px,5vw,42px)">Stone Record</h1><p style="max-width:620px;margin:0 auto 18px;font-size:15px;line-height:1.8;color:#625a50">This private owner record contains item-specific notes prepared in Japanese. Please contact Guiding Stones for an English explanation of the record, aftercare, sizing, or maintenance.</p><a style="display:inline-flex;align-items:center;justify-content:center;min-height:46px;padding:0 22px;background:#1d1d1d;color:#fff;text-decoration:none;border-radius:999px;font-weight:700" href="' + rootPath() + 'pages/contact-consultation">Contact Guiding Stones</a></section>';
    });
  }

  function scan() {
    normalize(document.body);
    document.querySelectorAll('.gs-rv-card,.gs-recent-card').forEach(hydrateRecent);
    if (!productPage()) document.querySelectorAll('.wishlist-storefront-page__card').forEach(hydrateWishlist);
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }

  function openLine(card) {
    var title = String(card.dataset.gsTitle || card.querySelector('.gs-rv-product-title')?.textContent || '').trim();
    var link = card.querySelector('a[href*="/products/"]');
    if (!title || !link) return false;
    var url = new URL(link.href, location.origin).href;
    var message = english()
      ? 'I would like to ask about this gemstone bracelet.\n\nProduct Name: ' + title + '\n\nProduct URL: ' + url + '\n\nPlease enter your question:'
      : 'この天然石についてお問い合わせします。\n\n商品名：' + title + '\n\n商品URL：' + url + '\n\nお問い合わせ内容をご記入ください：';
    window.open(LINE + encodeURIComponent(message), '_blank', 'noopener');
    return true;
  }

  function start() {
    migrate();
    scan();
    document.addEventListener('click', function (event) {
      if (english()) return;
      var button = event.target instanceof Element && event.target.closest('.gs-rv-line-button');
      var card = button?.closest('.gs-rv-card');
      if (!button || !card || !openLine(card)) return;
      event.preventDefault(); event.stopImmediatePropagation();
    }, true);
    new MutationObserver(queue).observe(document.body, {
      childList: true, subtree: true, characterData: true, attributes: true,
      attributeFilter: ['href', 'aria-label', 'title', 'placeholder', 'alt', 'value']
    });
    document.addEventListener('shopify:section:load', queue);
    document.addEventListener('shopify:section:reorder', queue);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
